<template>
  <div>
    <div v-show="false" class="secondary-dark-background">
      <div class="dovemed-wrapper">
        <div class="row py-5 m-footer">
          <div class="col-md-3 col-sm-6 mb-3">
            <h5>Quick Links</h5>
            <a class="hyper-link d-block "><div :style="{ color: getPrimaryColor() }">Q&A</div></a>
            <a class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">
                Treatments A-Z
              </div></a
            >
            <a class="hyper-link d-block "><div :style="{ color: getPrimaryColor() }">Resources</div></a>
            <a class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">
                Provider Directory
              </div></a
            >
            <a class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">
                Are you a provider?
              </div></a
            >
            <a class="hyper-link d-block "><div :style="{ color: getPrimaryColor() }">Crisis</div></a>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <h5>About Us</h5>
            <a :href="SSO_BASE_URL" target="_blank" class="hyper-link d-block ">
              <div :style="{ color: getPrimaryColor() }">
                What is myIBSteam?
              </div></a
            >
            <a :href="SSO_BASE_URL" target="_blank" class="hyper-link d-block ">
              <div :style="{ color: getPrimaryColor() }">
                Partner with us
              </div></a
            >
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`" target="_blank" class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">
                Terms of service
              </div></a
            >
            <a :href="SSO_BASE_URL" target="_blank" class="hyper-link d-block "><div :style="{ color: getPrimaryColor() }">Press/News</div></a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-privacy-policy`" target="_blank" class="hyper-link d-block"
              ><div :style="{ color: getPrimaryColor() }">
                Privacy policy
              </div></a
            >
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-privacy-policy`" target="_blank" class="hyper-link d-block"><div :style="{ color: getPrimaryColor() }">Cookie policy</div></a>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <h5>Help With This Site</h5>
            <a :href="SSO_BASE_URL" target="_blank" class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">
                Getting started
              </div></a
            >
            <a
              :href="`${SSO_BASE_URL}/help-center/search/faq?categoryId=f4fbe7d4-bfe2-482f-ad15-bba18b399675&subcategoryId=14e752da-7f8a-4044-9a62-c1ed942f9b8e`"
              target="_blank"
              class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">FAQ</div></a
            >
            <a :href="SSO_BASE_URL" target="_blank" class="hyper-link d-block "
              ><div :style="{ color: getPrimaryColor() }">
                Community guidelines
              </div></a
            >
            <a :href="SSO_BASE_URL" target="_blank" class="hyper-link d-block "><div :style="{ color: getPrimaryColor() }">Contact us</div></a>
          </div>
          <!-- <div class='col-md-3 col-sm-6 '>
            <h5>Get the myIBScircle mobile app</h5>
          </div> -->
        </div>
      </div>
    </div>
    <div
      :style="{
        background:
          $route.path.includes('searchpage') || $route.path.includes('circles')
            ? '#2a71d4'
            : getPrimaryColor()
      }"
    >
      <div class="dovemed-wrapper">
        <div class="dovemed-footer hide-in-mobile">
          <div class="dovemed-footer__left">
            <div>
              <img src="../../assets/dovemed-logo.svg" alt />
            </div>

            <div class="disclamier-text">
              &copy; {{ getYear }} MyCircles. All rights reserved.
            </div>
          </div>
          <div class="dovemed-footer__right">
            <div @click="$router.push({ name: 'AllCircles' })">home</div>
            <!-- <div @click="$router.push({ name: 'ContactUs' })">contact</div> -->
            <a :href="`${SSO_BASE_URL}/mycircles/contact-us`" target="_blank"> Contact </a>
            <a :href="`${SSO_BASE_URL}/help-center/search/faq?categoryId=f4fbe7d4-bfe2-482f-ad15-bba18b399675&subcategoryId=14e752da-7f8a-4044-9a62-c1ed942f9b8e`" target="_blank"> FAQ </a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-privacy-policy`" target="_blank"> Privacy Policy </a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`" target="_blank"> Terms of Use </a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-community-guidelines`" target="_blank"> Community Guidelines </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "Footer",
  computed: {
    getYear() {
      return moment().format("YYYY")
    },
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },
}
</script>

<style lang="scss" scoped>
.disclaimer-text {
  font-size: 12px;
}
.logo {
  position: initial;
  width: 130px;
  align-self: center;
}
// @media screen and (max-width: 581px) {
//   .dovemed-footer{
//     position: fixed;
//     width: 100%;
//     bottom: 0px;
//   }
// }
// @media screen and (max-width: 768px) {
//   .dovemed-footer{
//     position: fixed;
//     width: 100%;
//     bottom: 0px;
//   }
// }
// @media screen and (max-width: 1024px) {
//   .dovemed-footer{
//     position: fixed;
//     width: 100%;
//     bottom: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/App/Footer.vue